import React,{useState,useEffect} from 'react';

const TypeWriter = ({text,delay=100}) =>{
    const [currentIndex,setCurrentIndex] = useState(0);
    const [displayText,setDisplayText] = useState('');
    useEffect(() => {
        let t;
        let i=0;
        const getT =() =>{
            if(i<=text[currentIndex].length){
                setDisplayText(text[currentIndex].slice(0,i++));
                t = setTimeout(getT,delay);
            }else{
                clearTimeout(t);
                setCurrentIndex((pi)=>(pi+1)%text.length);
            }
        };
        getT();
        return()=> clearTimeout(t);
    },[text,currentIndex,delay]);
    return React.createElement('span',null,displayText);
};

const Home1 = ()=>{
    const text = ["Full Stack Developer","Software Engineer"];
    return React.createElement(TypeWriter,{text,delay:150});
};

export default Home1